import React, { useEffect, useState } from "react";
import './confirmationPopup.css';

function ConfirmationPopup ({ message, onConfirm, onCancel }) {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Activar la animación después de que el componente se monte
        setTimeout(() => setIsVisible(true), 50);
    }, []);

    const handleConfirm = () => {
        setIsVisible(false);
        setTimeout(onConfirm, 300); // Esperar a que termine la animación
    };

    const handleCancel = () => {
        setIsVisible(false);
        setTimeout(onCancel, 300); // Esperar a que termine la animación
    };
    return (
        <>
        <aside className={`dark-background ${isVisible ? 'show' : ''}`}></aside>
        <aside className={`confirmation-popup flex ${isVisible ? 'show' : ''}`}>
            <p className='message'>{message}</p>
            <span className='button-group flex'>
                <button type='button' onClick={handleConfirm} className='button'>Si</button>
                <button type='button' onClick={handleCancel} className='button'>No</button>
            </span>
        </aside>
        </>
    );
};

export default ConfirmationPopup;